// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file gateway/v1/device_data.proto (package gateway.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Pagination, PaginationMetadata } from "./core_pb";
import { file_gateway_v1_core } from "./core_pb";
import type { Timestamp, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gateway/v1/device_data.proto.
 */
export const file_gateway_v1_device_data: GenFile = /*@__PURE__*/
  fileDesc("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", [file_gateway_v1_core, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * DeviceDataPoint is one reading: whatever one device published on one topic at
 * one instant.
 *
 * The value is a JSON document, not a typed number, because device_data stores a
 * JSONB document per reading and this service does not interpret it. What the
 * keys mean is a contract between the device and the client; the gateway only
 * carries it across unchanged.
 *
 * @generated from message gateway.v1.DeviceDataPoint
 */
export type DeviceDataPoint = Message<"gateway.v1.DeviceDataPoint"> & {
  /**
   * time is the instant the reading refers to.
   *
   * @generated from field: google.protobuf.Timestamp time = 1;
   */
  time?: Timestamp | undefined;

  /**
   * device_uuid is the device that produced the reading.
   *
   * @generated from field: string device_uuid = 2;
   */
  deviceUuid: string;

  /**
   * topic is the MQTT topic the reading arrived on, e.g.
   * "dt/<device_uuid>/<fragment>/json-array". With no metric catalogue in the
   * schema, this is what identifies WHAT the reading is.
   *
   * @generated from field: string topic = 3;
   */
  topic: string;

  /**
   * value is the stored document, verbatim.
   *
   * Value rather than Struct: Struct is object-only, and the payload format is
   * not settled yet, so a device publishing a bare array or scalar would be
   * unrepresentable. Over Connect's JSON codec this renders as the JSON itself.
   *
   * Numbers arrive as doubles, which is what JSON gives and what the JSONB
   * column holds: an integer beyond 2^53 does not survive the round trip
   * exactly. Nothing in the pipeline validates the shape, so a client must
   * tolerate a key that is missing or has changed type between readings.
   *
   * @generated from field: google.protobuf.Value value = 4;
   */
  value?: Value | undefined;
};

/**
 * Describes the message gateway.v1.DeviceDataPoint.
 * Use `create(DeviceDataPointSchema)` to create a new message.
 */
export const DeviceDataPointSchema: GenMessage<DeviceDataPoint> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device_data, 0);

/**
 * GetDeviceDataRequest is the request message for retrieving every reading of a device.
 *
 * @generated from message gateway.v1.GetDeviceDataRequest
 */
export type GetDeviceDataRequest = Message<"gateway.v1.GetDeviceDataRequest"> & {
  /**
   * device_uuid is required and must be a canonical UUID. A well-formed UUID with
   * no readings, including one belonging to no device at all, returns an empty
   * list rather than an error.
   *
   * @generated from field: string device_uuid = 1;
   */
  deviceUuid: string;
};

/**
 * Describes the message gateway.v1.GetDeviceDataRequest.
 * Use `create(GetDeviceDataRequestSchema)` to create a new message.
 */
export const GetDeviceDataRequestSchema: GenMessage<GetDeviceDataRequest> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device_data, 1);

/**
 * GetDeviceDataResponse is the response message for the GetDeviceData RPC.
 *
 * @generated from message gateway.v1.GetDeviceDataResponse
 */
export type GetDeviceDataResponse = Message<"gateway.v1.GetDeviceDataResponse"> & {
  /**
   * data is ordered newest first: (time, topic) descending.
   *
   * @generated from field: repeated gateway.v1.DeviceDataPoint data = 1;
   */
  data: DeviceDataPoint[];
};

/**
 * Describes the message gateway.v1.GetDeviceDataResponse.
 * Use `create(GetDeviceDataResponseSchema)` to create a new message.
 */
export const GetDeviceDataResponseSchema: GenMessage<GetDeviceDataResponse> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device_data, 2);

/**
 * GetDeviceDataByPageRequest is the request message for retrieving one page of a device's readings.
 *
 * @generated from message gateway.v1.GetDeviceDataByPageRequest
 */
export type GetDeviceDataByPageRequest = Message<"gateway.v1.GetDeviceDataByPageRequest"> & {
  /**
   * device_uuid is required and must be a canonical UUID.
   *
   * @generated from field: string device_uuid = 1;
   */
  deviceUuid: string;

  /**
   * pagination is required. page_index is 1-based; values < 1 are rejected.
   *
   * @generated from field: gateway.v1.Pagination pagination = 2;
   */
  pagination?: Pagination | undefined;
};

/**
 * Describes the message gateway.v1.GetDeviceDataByPageRequest.
 * Use `create(GetDeviceDataByPageRequestSchema)` to create a new message.
 */
export const GetDeviceDataByPageRequestSchema: GenMessage<GetDeviceDataByPageRequest> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device_data, 3);

/**
 * GetDeviceDataByPageResponse is the response message for the GetDeviceDataByPage RPC.
 *
 * @generated from message gateway.v1.GetDeviceDataByPageResponse
 */
export type GetDeviceDataByPageResponse = Message<"gateway.v1.GetDeviceDataByPageResponse"> & {
  /**
   * data is ordered newest first: (time, topic) descending.
   *
   * @generated from field: repeated gateway.v1.DeviceDataPoint data = 1;
   */
  data: DeviceDataPoint[];

  /**
   * metadata.total_count is EXACT, counted for this device on every call. There is
   * no estimate form: approximate_row_count takes a whole relation and accepts no
   * filter, so a per-device count has to be counted.
   *
   * @generated from field: gateway.v1.PaginationMetadata metadata = 2;
   */
  metadata?: PaginationMetadata | undefined;
};

/**
 * Describes the message gateway.v1.GetDeviceDataByPageResponse.
 * Use `create(GetDeviceDataByPageResponseSchema)` to create a new message.
 */
export const GetDeviceDataByPageResponseSchema: GenMessage<GetDeviceDataByPageResponse> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device_data, 4);

/**
 * GetDeviceDataByTimeRangeRequest is the request message for retrieving a device's readings inside a time window.
 *
 * @generated from message gateway.v1.GetDeviceDataByTimeRangeRequest
 */
export type GetDeviceDataByTimeRangeRequest = Message<"gateway.v1.GetDeviceDataByTimeRangeRequest"> & {
  /**
   * device_uuid is required and must be a canonical UUID.
   *
   * @generated from field: string device_uuid = 1;
   */
  deviceUuid: string;

  /**
   * from is the inclusive start of the window. Required.
   *
   * @generated from field: google.protobuf.Timestamp from = 2;
   */
  from?: Timestamp | undefined;

  /**
   * to is the exclusive end of the window. Required, after `from`, and at most
   * 31 days after it.
   *
   * @generated from field: google.protobuf.Timestamp to = 3;
   */
  to?: Timestamp | undefined;
};

/**
 * Describes the message gateway.v1.GetDeviceDataByTimeRangeRequest.
 * Use `create(GetDeviceDataByTimeRangeRequestSchema)` to create a new message.
 */
export const GetDeviceDataByTimeRangeRequestSchema: GenMessage<GetDeviceDataByTimeRangeRequest> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device_data, 5);

/**
 * GetDeviceDataByTimeRangeResponse is the response message for the GetDeviceDataByTimeRange RPC.
 *
 * @generated from message gateway.v1.GetDeviceDataByTimeRangeResponse
 */
export type GetDeviceDataByTimeRangeResponse = Message<"gateway.v1.GetDeviceDataByTimeRangeResponse"> & {
  /**
   * data is ordered newest first: (time, topic) descending.
   *
   * @generated from field: repeated gateway.v1.DeviceDataPoint data = 1;
   */
  data: DeviceDataPoint[];

  /**
   * truncated is true when the window held more readings than the server cap
   * (43200), in which case `data` holds only the newest ones.
   *
   * @generated from field: bool truncated = 2;
   */
  truncated: boolean;
};

/**
 * Describes the message gateway.v1.GetDeviceDataByTimeRangeResponse.
 * Use `create(GetDeviceDataByTimeRangeResponseSchema)` to create a new message.
 */
export const GetDeviceDataByTimeRangeResponseSchema: GenMessage<GetDeviceDataByTimeRangeResponse> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device_data, 6);

/**
 * GetDeviceGeoDataByTimeRangeRequest is the request message for retrieving a device's readings with a position inside a time window.
 *
 * @generated from message gateway.v1.GetDeviceGeoDataByTimeRangeRequest
 */
export type GetDeviceGeoDataByTimeRangeRequest = Message<"gateway.v1.GetDeviceGeoDataByTimeRangeRequest"> & {
  /**
   * device_uuid is required and must be a canonical UUID.
   *
   * @generated from field: string device_uuid = 1;
   */
  deviceUuid: string;

  /**
   * from is the inclusive start of the window. Required.
   *
   * @generated from field: google.protobuf.Timestamp from = 2;
   */
  from?: Timestamp | undefined;

  /**
   * to is the exclusive end of the window. Required, after `from`, and at most
   * 31 days after it.
   *
   * @generated from field: google.protobuf.Timestamp to = 3;
   */
  to?: Timestamp | undefined;
};

/**
 * Describes the message gateway.v1.GetDeviceGeoDataByTimeRangeRequest.
 * Use `create(GetDeviceGeoDataByTimeRangeRequestSchema)` to create a new message.
 */
export const GetDeviceGeoDataByTimeRangeRequestSchema: GenMessage<GetDeviceGeoDataByTimeRangeRequest> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device_data, 7);

/**
 * GetDeviceGeoDataByTimeRangeResponse is the response message for the GetDeviceGeoDataByTimeRange RPC.
 *
 * @generated from message gateway.v1.GetDeviceGeoDataByTimeRangeResponse
 */
export type GetDeviceGeoDataByTimeRangeResponse = Message<"gateway.v1.GetDeviceGeoDataByTimeRangeResponse"> & {
  /**
   * data is ordered newest first: (time, topic) descending.
   *
   * @generated from field: repeated gateway.v1.DeviceDataPoint data = 1;
   */
  data: DeviceDataPoint[];

  /**
   * truncated is true when the window held more readings with a position than
   * the server cap (43200), in which case `data` holds only the newest ones.
   *
   * @generated from field: bool truncated = 2;
   */
  truncated: boolean;
};

/**
 * Describes the message gateway.v1.GetDeviceGeoDataByTimeRangeResponse.
 * Use `create(GetDeviceGeoDataByTimeRangeResponseSchema)` to create a new message.
 */
export const GetDeviceGeoDataByTimeRangeResponseSchema: GenMessage<GetDeviceGeoDataByTimeRangeResponse> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device_data, 8);

/**
 * DeviceDataService defines the gRPC service for reading device telemetry.
 *
 * -------------------------------------------------------------------------
 * Device data read operations
 * -------------------------------------------------------------------------
 *
 * @generated from service gateway.v1.DeviceDataService
 */
export const DeviceDataService: GenService<{
  /**
   * GetDeviceData returns every reading stored for one device, newest first.
   *
   * The response is UNBOUNDED: its size is proportional to the device's whole
   * history, and the server holds the entire result in memory while building it,
   * so concurrent calls multiply that cost. Before using it, know that:
   *
   *   - gRPC clients fail first. grpc-go defaults MaxCallRecvMsgSize to 4 MB and
   *     answers ResourceExhausted well before the server itself struggles. How
   *     many readings fit in that budget depends on the size of each stored
   *     document, so it is a property of the payload, not a fixed number.
   *   - The read carries a 30 second deadline by default, but a caller-supplied
   *     deadline replaces it outright. A client sending Connect-Timeout-Ms or
   *     grpc-timeout sets the real budget, in either direction.
   *   - A timeout part way through the read closes the pooled database
   *     connection, because the protocol stream can no longer be resynchronised.
   *     Calling this repeatedly against a large device degrades every other RPC.
   *
   * Callers that need bounded memory, or that are paging a UI, want
   * GetDeviceDataByPage instead.
   *
   * @generated from rpc gateway.v1.DeviceDataService.GetDeviceData
   */
  getDeviceData: {
    methodKind: "unary";
    input: typeof GetDeviceDataRequestSchema;
    output: typeof GetDeviceDataResponseSchema;
  },
  /**
   * GetDeviceDataByPage returns one page of a device's readings, newest first.
   *
   * Paging is by offset over a newest-first ordering, so while the device is
   * actively ingesting, new readings land at the front and shift everything
   * back: a row already shown on page 1 can appear again on page 2. Reading a
   * consistent snapshot of a live device needs a keyset cursor, which this
   * service does not implement yet.
   *
   * @generated from rpc gateway.v1.DeviceDataService.GetDeviceDataByPage
   */
  getDeviceDataByPage: {
    methodKind: "unary";
    input: typeof GetDeviceDataByPageRequestSchema;
    output: typeof GetDeviceDataByPageResponseSchema;
  },
  /**
   * GetDeviceDataByTimeRange returns one device's readings inside [from, to),
   * newest first.
   *
   * The window is bounded (at most 31 days) and so is the response: when the
   * window holds more readings than the server cap (43200, one reading per
   * minute over 30 days), only the newest ones are returned and `truncated` is
   * set. A caller that needs the rest narrows the
   * window, using the oldest returned time as the new `to`.
   *
   * @generated from rpc gateway.v1.DeviceDataService.GetDeviceDataByTimeRange
   */
  getDeviceDataByTimeRange: {
    methodKind: "unary";
    input: typeof GetDeviceDataByTimeRangeRequestSchema;
    output: typeof GetDeviceDataByTimeRangeResponseSchema;
  },
  /**
   * GetDeviceGeoDataByTimeRange is GetDeviceDataByTimeRange restricted to the
   * readings that carry a usable position: the document has `latitude` and
   * `longitude`, and `gps_valid` is not false (a missing `gps_valid` counts as
   * valid). The filter runs in the database, so readings without a fix are
   * neither read nor sent, and the cap only counts readings with a position.
   *
   * It only checks presence: the values are still the device's, so a client must
   * still reject coordinates that are not numbers, are out of range or are 0,0.
   *
   * @generated from rpc gateway.v1.DeviceDataService.GetDeviceGeoDataByTimeRange
   */
  getDeviceGeoDataByTimeRange: {
    methodKind: "unary";
    input: typeof GetDeviceGeoDataByTimeRangeRequestSchema;
    output: typeof GetDeviceGeoDataByTimeRangeResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gateway_v1_device_data, 0);

